import {merge, map} from 'lodash';
import moment from 'moment';
import {inlineSchema} from "./utils";
import i18n from 'src/i18n';
import * as Member from './membership';
import * as Profile from './profile';
import * as ServiceLocation from './service_location';
import * as EmergencyContact from './emergency_contact';
import * as UserExperience from './user_experience';
import * as MedicalHistory from './medical_history';

export default function () {
  return {
    subprofile_id: {type: 'id', readonly: true, cat: 'fields.cat.general'},
    created_at: {type: 'datetime', readonly: true, cat: 'fields.cat.general'},
    tags: {type: 'tags', unique: true},
    status: {type: 'select', items: ['status.active', 'status.inactive']},
    type: {type: 'string'},
    creator: {type: 'schema', schema: Member, external: true, readonly: true, cat: 'fields.cat.general', list: 1},
    'details.profile': {
      type: 'schema',
      schema: Profile,
      expand: true,
      cat: 'fields.cat.general',
    },
    'details.relationship': {
      type: 'string',
      cat: 'fields.cat.general',
    },
    'details.medical_history': {
      type: 'schema',
      cat: 'fields.cat.general',
      schema: MedicalHistory,
    },
    'details.remark': {type: 'string', cat: 'fields.cat.general'},
    // stat: {
    //   readonly: true,
    //   type: 'schema', schema: inlineSchema({
    //     "view": {type: 'number'},
    //     "click": {type: 'number'},
    //   }),
    // },
  };
}



// WEBPACK FOOTER //
// ./src/schemas/subprofile_db.js